import React from 'react';

import { ThemeProvider } from '@volkswagen-onehub/components-core';

import { CarNicknameFormView } from '../CarNicknameFormView';
import { useMyVwContext } from '../../../../../shared/hooks/use-my-vw-context';
import { useToast } from '../../../../../shared/context/ToastContext';
import { useTrackingManager } from '../../../../../shared/hooks/use-tracking-manager';
import { useVehicle } from '../../../../../app/providers/VehicleContext';

export const useNicknameLayerData = (requestClose: () => void, onChange: () => void) => {
  const { translationHandler } = useMyVwContext();
  const { userPreferredVehicle, updateVehicleNickname, isUpdatingNickname } = useVehicle();
  const { showToast } = useToast();
  const trackingManager = useTrackingManager();

  const onSuccess = () => {
    requestClose();
    showToast(translationHandler(userPreferredVehicle?.vehicleNickname ? 'vehicleManagement.interactive.card.vehicle.header.edit.nickname.success' : 'vehicleManagement.interactive.card.vehicle.header.add.nickname.success'), 'Success');
  };
  const onError = () => {
    requestClose();
    showToast(translationHandler(userPreferredVehicle?.vehicleNickname ? 'vehicleManagement.interactive.card.vehicle.header.edit.nickname.error' : 'vehicleManagement.interactive.card.vehicle.header.add.nickname.error'), 'Alert');
  };
  const title = translationHandler('vehicleManagement.nickname.title');
  const content = (
    <ThemeProvider theme='main'>
      <CarNicknameFormView
        translationHandler={translationHandler}
        trackingManager={trackingManager}
        userPreferredVehicle={userPreferredVehicle}
        updateVehicleNickname={updateVehicleNickname}
        isUpdatingNickname={isUpdatingNickname}
        onSuccess={onSuccess}
        onError={onError}
        onChange={onChange}
      />
    </ThemeProvider>
  );

  return { title, content };
};
